<template>
  <option :selected="location.code === selected" :value="location.code">
    {{ $t(location.name) }}
  </option>
</template>
<script>
export default {
  name: 'HomeLocationItem',
  props: {
    location: {
      type: Object,
      required: true
    },
    selected: {
      type: String,
      required: false,
      default: () => null
    }
  }
}
</script>
<style lang="scss" scoped>
  #select:disabled ~ .items #text {
    background: #eee;
  }

  .items {
    display: block;
    min-height: 38px;
    position: absolute;
    border: 1px solid #ddd;
    overflow: hidden;
    width: 240px;
    cursor: pointer;
    border-top-left-radius: 10px;
    border-bottom-left-radius: 10px;
    z-index: 1;
  }

  #select:not(:checked) ~ .items {
    height: 30px;
  }

  .items label {
    border-top: 2px solid #ddd;
    display: none;
    padding-left: 10px;
    background: white;
    text-align: left    ;
  }

  .items label:hover {
    background: #eee;
    cursor: pointer;
  }

  #select:checked ~ .items {
    padding-top: 38px;
  }

  #select:checked ~ .items label {
    display: block;
  }

  .items input:checked + label {
    display: block!important;
    border: none;
    background: white;
  }

  /*#select:checked ~ .bg*/
  /*{*/
  /*position: fixed;*/
  /*top: 0;*/
  /*left: 0;*/
  /*bottom: 0;*/
  /*right: 0;*/
  /*z-index: 0;*/
  /*background: rgba(0,0,0,0.4);*/
  /*}*/
</style>
